export default "__VITE_ASSET__8f32044a__"